class VideoBanner extends HTMLElement {
  connectedCallback() {
    this.playBtn = this.querySelector('[data-video-banner-play]');
    this.video = this.querySelector('[data-video-banner-video]');
    this.hasPoster = this.video?.dataset.hasPoster === 'true';

    if (!this.playBtn || !this.video) return;

    this.playBtn.addEventListener('click', this.handlePlay.bind(this));
    this.video.addEventListener('ended', this.handleEnded.bind(this));
  }

  handlePlay() {
    this.video.play();
    this.video.classList.add('video-banner__video--active');
    this.playBtn.classList.add('video-banner__play-btn--hidden');
  }

  handleEnded() {
    if (this.hasPoster) {
      this.video.classList.remove('video-banner__video--active');
    }
    this.playBtn.classList.remove('video-banner__play-btn--hidden');
  }
}

customElements.define('video-banner', VideoBanner);
